import { RootState } from "../../../../../redux/store";

export const isItemsLoading = (state:RootState) => state.customerSegments.itemsLoading;
export const isItemActionLoading = (state:RootState) => state.customerSegments.actionsLoading;
export const getItems = (state:RootState) => state.customerSegments.items;
export const getItemsSelect = (state:RootState) => state.customerSegments.dropDownItems;
export const getItemsCount = (state:RootState) => state.customerSegments.itemsCount;
export const getItemForEdit = (state:RootState) => state.customerSegments.itemForEdit;
export const getError = (state:RootState) => state.customerSegments.error;
export const getErrorAction = (state:RootState) => state.customerSegments.errorAction;
export const validationErrors = (state: RootState) => state.customerSegments.validationErrors;

